import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');

function EditCustomerPassword() {
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', password: '', cpassword: '' });
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');

    const validate = () => {
        const newErrors = {};
        if (!formData.password) newErrors.password = "Password feild is required.";
        if (!formData.cpassword) newErrors.cpassword = "Confirm Password feild is required.";
        if (formData.password && formData.password.length < 8) newErrors.password = "Password must be at least 8 characters.";
        if (formData.password !== formData.cpassword) newErrors.password = "Password and Confirm Password do not match.";
        return newErrors;
    };


    // Define an async function inside useEffect
    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchuserdetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;

            const customdata = {
                name: resdata.name,
                email: resdata.email,
                phone: resdata.phone
            }
            setFormData(customdata);
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        }
    };


    useEffect(() => {
        document.documentElement.className = "";

        fetchData();
    }, [id]);

    /*const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : e.target.value });
    };*/


    const handleChangePassword = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                //API URL
                const response = await axios.patch(`${process.env.REACT_APP_API_URL}/editpassword/${id}`, {
                    "password": formData.password,
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    //alert('Module added successfully!');
                    //redirectHistory('/customers'); // redirect to listing page
                    setAlert({ type: "success", message: "The customer’s password has been changed successfully." });
                    setTimeout(() => redirectHistory('/customers'), 2500); // thoda delay deke redirect

                }

            } catch (err) {
                const customerror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
                setAlert({ type: "error", message: customerror });
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/customers" className='btn btn-primary'>Customers</Link></li>
                        <li>Update Password</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Update Password
                            </p>
                        </header>
                        <div className="card-content">
                            <form onSubmit={handleChangePassword}>
                                {alert.message && (
                                    <AlertMessage
                                        type={alert.type}
                                        message={alert.message}
                                        onClose={() => setAlert({ type: "", message: "" })}
                                    />
                                )}
                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label" htmlFor="name">Username</label>
                                        <div className="control">
                                            <div className="input" readOnly id="name" type="text" >{formData.name}</div>
                                        </div>
                                        {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label">Email</label>
                                        <div className="control">
                                            <div className="input" readOnly id="email" type="text" >{formData.email}</div>
                                        </div>
                                        {errors.email && <p className="help" style={{ color: 'red' }}>{errors.email}</p>}
                                    </div>
                                </div>
                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label">Password</label>
                                        <div className="control">
                                            <input className="input" id="password" type="password" placeholder="Password" value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} />
                                        </div>
                                        {errors.password && <p className="help" style={{ color: 'red' }}>{errors.password}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label">Confirm Password</label>
                                        <div className="control">
                                            <input className="input" id="cpassword" type="password" placeholder="Confirm Password" value={formData.cpassword} onChange={e => setFormData({ ...formData, cpassword: e.target.value })} />
                                        </div>
                                        {errors.cpassword && <p className="help" style={{ color: 'red' }}>{errors.cpassword}</p>}
                                    </div>
                                </div>
                                <div class="flex justify-center items-center">
                                    <div class="field grouped">
                                        <div class="control">
                                            <button type="submit" class="button green">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditCustomerPassword;